module.exports = __webpack_public_path__ + "379a12ca8011c0cfd97d113e430b6b12.svg";